import {GROUPS_VINO} from 'plugins/modules/filter/constants/filterGroups/vino/groups';
import {IFilterConfig} from 'plugins/modules/filter/types';

export const FILTERS_CONFIG_VINO: IFilterConfig[] = [
    {
        code: 'main',
        group: GROUPS_VINO.PRICE,
        itemWithCollapse: false,
    },
    {
        code: 'sale',
        group: null,
        itemWithCollapse: false,
    },
    {
        code: 'present_pack',
        group: null,
        itemWithCollapse: false,
    },
    {
        code: 'color',
        group: GROUPS_VINO.COLOR,
        itemWithCollapse: false,
    },
    {
        code: 'orange',
        group: GROUPS_VINO.COLOR,
        itemWithCollapse: false,
    },
    {
        code: 'country',
        group: GROUPS_VINO.GEO,
        itemWithCollapse: true,
    },
    {
        code: 'region',
        group: GROUPS_VINO.GEO,
        itemWithCollapse: true,
    },
    {
        code: 'appellason',
        group: GROUPS_VINO.GEO,
        itemWithCollapse: true,
    },
    {
        code: 'sugar_type',
        group: null,
        itemWithCollapse: true,
    },
    {
        code: 'monosort',
        group: GROUPS_VINO.GRAPE,
        itemWithCollapse: false,
    },
    {
        code: 'grape',
        group: GROUPS_VINO.GRAPE,
        itemWithCollapse: false,
    },
    {
        code: 'manufacturer',
        group: null,
        itemWithCollapse: true,
    },
    {
        code: 'art',
        group: null,
        itemWithCollapse: false,
    },
    {
        code: 'volume',
        group: null,
        itemWithCollapse: true,
        itemWithSearch: false,
    },
    {
        code: 'year',
        group: null,
        itemWithCollapse: true,
    },
    {
        code: 'bezalkogolnoe',
        group: GROUPS_VINO.ALCOHOL,
        itemWithCollapse: false,
    },
    {
        code: 'strong_wine',
        group: GROUPS_VINO.ALCOHOL,
        itemWithCollapse: true,
    },
    {
        code: 'strength',
        group: GROUPS_VINO.ALCOHOL,
        itemWithCollapse: true,
    },
    {
        code: 'any_rating',
        group: GROUPS_VINO.RATING,
        itemWithCollapse: false,
    },
    {
        code: 'reviews_rating',
        group: GROUPS_VINO.RATING,
        itemWithCollapse: true,
    },
    {
        code: 'rating_type',
        group: GROUPS_VINO.RATING,
        itemWithCollapse: true,
    },
    {
        code: 'rating_num',
        group: GROUPS_VINO.RATING,
        itemWithCollapse: true,
    },
    {
        code: 'food',
        group: GROUPS_VINO.GASTRONOMY,
        itemWithCollapse: true,
    },
    {
        code: 'flavor',
        group: GROUPS_VINO.GASTRONOMY,
        itemWithCollapse: true,
    },
    {
        code: 'aging_tank',
        group: GROUPS_VINO.FEATURES,
        itemWithCollapse: true,
    },
    {
        code: 'cultivation_type',
        group: GROUPS_VINO.FEATURES,
        itemWithCollapse: true,
    },
    {
        code: 'cultivation_type',
        group: GROUPS_VINO.FEATURES,
        itemWithCollapse: true,
    },
    {
        code: 'cosher',
        group: GROUPS_VINO.FEATURES,
        itemWithCollapse: false,
    },
    {
        code: 'vegan',
        group: GROUPS_VINO.FEATURES,
        itemWithCollapse: false,
    },
    {
        code: 'natural',
        group: GROUPS_VINO.FEATURES,
        itemWithCollapse: true,
    },
    {
        code: 'online_showcase',
        group: null,
        itemWithCollapse: false,
    },
    {
        code: 'vinoteka',
        group: null,
        itemWithCollapse: true,
    },
    {
        code: 'sales',
        group: null,
        itemWithCollapse: true,
    },
];
